// src/components/modals/NewCommentModal.tsx
import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input } from "reactstrap";

interface NewCommentModalProps {
  isOpen: boolean;
  toggle: () => void;
  comment: string;
  setComment: (text: string) => void;
  userRole: string;
  viewerCode: string;
  setViewerCode: (text: string) => void;
  onConfirm: () => void;
}

const NewCommentModal: React.FC<NewCommentModalProps> = ({
  isOpen, toggle, comment, setComment, userRole, viewerCode, setViewerCode, onConfirm
}) => (
  <Modal isOpen={isOpen} toggle={toggle} className={`${localStorage.getItem("mode") ? localStorage.getItem("mode") : "light"}`}>
    <ModalHeader>Novo Comentário</ModalHeader>
    <ModalBody className="modal-body-style">
      <Input
        type="textarea"
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        rows={8}
        placeholder="Seu comentário"
        className="input-modal theme-text-color"
      />
      {userRole === "Viewer" && (
        <Input
          type="text"
          className="mt-2 input-modal theme-text-color"
          value={viewerCode}
          onChange={(e) => setViewerCode(e.target.value)}
          placeholder="Código"
        />
      )}
    </ModalBody>
    <ModalFooter className="modal-footer-style">
      <Button color="primary" onClick={onConfirm} id="btn-comment-new">Confirmar</Button>
      <Button color="secondary" onClick={toggle}>Cancelar</Button>
    </ModalFooter>
  </Modal>
);

export default NewCommentModal;
